import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=359a63b0&scoped=true&"
var script = {}
import style0 from "./activity.vue?vue&type=style&index=0&id=359a63b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a63b0",
  null
  
)

export default component.exports